"use strict";
/**
 * Soccer Mode UI
 * Slippage curves and hint/factor display updates for the soccer order
 * button layout (MISC / EXT split top row, GOAL?, GOAL, RED CARD, SELL per
 * side). Layout visibility is handled by sport-mode.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCCER_SLIPPAGE_CURVES = void 0;
exports.getSoccerSlippage = getSoccerSlippage;
exports.updateSoccerSlippageHints = updateSoccerSlippageHints;
exports.updateSoccerFactorDisplay = updateSoccerFactorDisplay;
const state_1 = require("../state");
const sport_mode_1 = require("./sport-mode");
/**
 * Factor curves per match event. All start at 0 (exact low ask at factor 0).
 * Ordered by how hard the event reprices the market: GOAL? (looks like a
 * goal but could be pulled back / VAR) ramps gentlest, RED CARD sits in
 * between, and a certain GOAL ramps hardest — steeper than baseball's HR,
 * since a confirmed goal is the largest single repricing event across the
 * sport layouts.
 */
exports.SOCCER_SLIPPAGE_CURVES = {
    goal_maybe: { base: 0, linear: 0.9, quadratic: 0.05 },
    goal: { base: 0, linear: 1.5, quadratic: 0.1 },
    red_card: { base: 0, linear: 1.1, quadratic: 0.07 },
};
/**
 * Calculate effective slippage for a match event and factor.
 * At factor 0 every event type returns 0 (fire at the exact low ask).
 */
function getSoccerSlippage(event, factor) {
    return (0, sport_mode_1.evaluateSlippageCurve)(exports.SOCCER_SLIPPAGE_CURVES[event], factor);
}
// ---------------------------------------------------------------------------
// Hint + factor display
// ---------------------------------------------------------------------------
/**
 * Update all slippage hint labels on soccer buttons for the given factor.
 *
 * In combined mode (soccer + manual price), the MISC/GOAL?/GOAL/RED CARD hint
 * elements show manual prices managed by the sport pricing engine's hint
 * refresh; this function only updates them when NOT in combined mode,
 * avoiding a flash of stale slippage values. MISC shows 0% at every factor;
 * EXT has no slippage.
 */
function updateSoccerSlippageHints(factor) {
    const combined = (0, sport_mode_1.isCombinedPricingMode)((0, state_1.getState)().tradingSettings);
    const sides = ["a", "b"];
    if (!combined) {
        for (const side of sides) {
            const misc = document.getElementById(`sc-misc-${side}-slip`);
            if (misc)
                misc.textContent = "0%";
            const goalMaybe = document.getElementById(`sc-goal-maybe-${side}-hint`);
            if (goalMaybe)
                goalMaybe.textContent = `${getSoccerSlippage("goal_maybe", factor)}%`;
            const goal = document.getElementById(`sc-goal-${side}-hint`);
            if (goal)
                goal.textContent = `${getSoccerSlippage("goal", factor)}%`;
            const redCard = document.getElementById(`sc-red-${side}-hint`);
            if (redCard)
                redCard.textContent = `${getSoccerSlippage("red_card", factor)}%`;
        }
    }
}
/**
 * Update the soccer factor display and slider, then refresh the slippage
 * hints. The slider range (0–20) is narrower than the ± buttons' clamp (40);
 * assigning past the max pegs the slider there.
 */
function updateSoccerFactorDisplay(factor) {
    const display = document.getElementById("sc-factor-display");
    if (display)
        display.textContent = factor.toString();
    const slider = document.getElementById("sc-factor-slider");
    if (slider)
        slider.value = factor.toString();
    updateSoccerSlippageHints(factor);
}
